<template>
  <div class="divider-line"></div>
</template>

<script>
export default {
  name: 'divider-line',
}
</script>

<style>
.divider-line {
  border-top: 1px solid rgb(228, 226, 226);
  margin: 10px 0;
}
</style>